import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit"]
  static values = { expected: String }

  connect() {
    this.element.addEventListener("submit", this.guard)
    this.sync()
  }

  disconnect() {
    this.element.removeEventListener("submit", this.guard)
  }

  sync() {
    if (!this.hasSubmitTarget) return
    this.submitTarget.disabled = !this.matches
  }

  guard = (event) => {
    if (!this.matches) event.preventDefault()
  }

  get matches() {
    return this.hasInputTarget && this.inputTarget.value === this.expectedValue
  }
}
